import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_DEFAULT_URL
// authorization headers
export function getAuthHeaders() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return {
            'Authorization': 'Bearer ' + user.token,
            'Access-Control-Allow-Origin': '*',
        };
    } else {
        return {};
    }
}

// form-data + authorization headers
export function getFormDataHeaders() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.token) {
        return {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'Bearer ' + user.token
        };
    } else {
        return {};
    }
}

export default axios